import { ThemeProvider } from 'styled-components';
import { GlobalStyles, theme } from '~/styles';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { AppetizerProvider } from '@getinapp/appetizer';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import i18n from '@getin-widgets/i18n';
import { initReactI18next } from 'react-i18next';
import { useState } from 'react';

i18n.use(initReactI18next).init();

function MyApp({ Component, pageProps }: AppProps) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <AppetizerProvider>
      <Head>
        <title>Get In - Entre na fila via QR Code</title>

        <link rel="shortcut icon" href="/img/icon-192-rounded.png" />
        <link rel="apple-touch-icon" href="/img/icon-512.png" />
        <link
          rel="preload"
          href="/fonts/MaisonNeueExt-Light.ttf"
          as="font"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/ACaslonPro-Italic.otf"
          as="font"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/MaisonNeueExt-Medium.ttf"
          as="font"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/fonts/MaisonNeueExt-Bold.ttf"
          as="font"
          crossOrigin="anonymous"
        />
      </Head>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <GlobalStyles />
          <Component {...pageProps} />
          <ToastContainer />
        </ThemeProvider>
      </QueryClientProvider>
    </AppetizerProvider>
  );
}

export default MyApp;
